import React, { useEffect, useState } from "react";

import label from "../../labels/administration_en.json";

import PresentAbsentReport from "../../../statistical-report/components/PresentAbsentReport";
import Statistics from "../../../statistical-report/components/Statistics";

import AdmitedCandidates from "../../../recommendationProcess/components/recommendation/admitedCandidates";
import InterviewedCandidates from "../../../recommendationProcess/components/recommendation/interviewedCandidates";
import PresentCandidates from "../../../recommendationProcess/components/recommendation/presentCandidates";
import MeritoriousCandidates from "../../../recommendationProcess/components/recommendation/meritoriousCandidates";
import QualifiedCandidates from "../../../recommendationProcess/components/recommendation/qualifiedCandidates";

const StatisticalReports = () => {

  const [stepName, setName] = useState("presentabsent");


  return (
    <div className="commonContentArea">
      <h5 className="labelMargin"> {label.StatisticalReports} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">

          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "presentabsent"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="presentabsent"
              id="presentabsent-tab"
              onClick={() => setName("presentabsent")}
              data-toggle="tab"
              role="tab"
              aria-controls="presentabsent"
              aria-selected="false"
            >
              <span>Present/Absent</span>
            </a>
          </li>

          <li className="nav-item" key="2">
            <a
              href="#"
              className={
                stepName === "statistics"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="statistics"
              id="statistics-tab"
              onClick={() => setName("statistics")}
              data-toggle="tab"
              role="tab"
              aria-controls="statistics"
              aria-selected="false"
            >
              <span>Statistics</span>
            </a>
          </li>

          <li className="nav-item" key="3">
            <a
              href="#"
              className={
                stepName === "admitedCandidates"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="admitedCandidates"
              id="admitedCandidates-tab"
              onClick={() => setName("admitedCandidates")}
              data-toggle="tab"
              role="tab"
              aria-controls="admitedCandidates"
              aria-selected="false"
            >
              <span>Admitted Candidates</span>
            </a>
          </li>

          <li className="nav-item" key="4">
            <a
              href="#"
              className={
                stepName === "interviewedCandidates"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="interviewedCandidates"
              id="interviewedCandidates-tab"
              onClick={() => setName("interviewedCandidates")}
              data-toggle="tab"
              role="tab"
              aria-controls="interviewedCandidates"
              aria-selected="false"
            >
              <span>Interviewed Candidates</span>
            </a>
          </li>

          <li className="nav-item" key="5">
            <a
              href="#"
              className={
                stepName === "presentCandidates"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="presentCandidates"
              id="presentCandidates-tab"
              onClick={() => setName("presentCandidates")}
              data-toggle="tab"
              role="tab"
              aria-controls="presentCandidates"
              aria-selected="false"
            >
              <span>Present Candidates</span>
            </a>
          </li>

          <li className="nav-item" key="6">
            <a
              href="#"
              className={
                stepName === "meritoriousCandidates"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="meritoriousCandidates"
              id="meritoriousCandidates-tab"
              onClick={() => setName("meritoriousCandidates")}
              data-toggle="tab"
              role="tab"
              aria-controls="meritoriousCandidates"
              aria-selected="false"
            >
              <span>Meritorious Candidates</span>
            </a>
          </li>

          <li className="nav-item" key="7">
            <a
              href="#"
              className={
                stepName === "qualifiedCandidates"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="qualifiedCandidates"
              id="qualifiedCandidates-tab"
              onClick={() => setName("qualifiedCandidates")}
              data-toggle="tab"
              role="tab"
              aria-controls="qualifiedCandidates"
              aria-selected="false"
            >
              <span>Qualified Candidates</span>
            </a>
          </li>


        </ul>


        <div className="tab-content border border-light" id="myTabContent">

          <div
            className={
              stepName === "statistics"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="statistics"
            role="tabpanel"
            aria-labelledby="statistics-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <Statistics key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "presentabsent"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="presentabsent"
            role="tabpanel"
            aria-labelledby="presentabsent-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <PresentAbsentReport key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "admitedCandidates"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="admitedCandidates"
            role="tabpanel"
            aria-labelledby="admitedCandidates-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <AdmitedCandidates key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "interviewedCandidates"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="interviewedCandidates"
            role="tabpanel"
            aria-labelledby="interviewedCandidates-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <InterviewedCandidates key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "presentCandidates"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="presentCandidates"
            role="tabpanel"
            aria-labelledby="presentCandidates-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <PresentCandidates key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "meritoriousCandidates"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="meritoriousCandidates"
            role="tabpanel"
            aria-labelledby="meritoriousCandidates-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <MeritoriousCandidates key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "qualifiedCandidates"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="qualifiedCandidates"
            role="tabpanel"
            aria-labelledby="qualifiedCandidates-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <QualifiedCandidates key={stepName} />
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}

export default StatisticalReports;